import { useState } from "react";
import { Provider } from "react-redux";
import { createStore } from "./store";
import App from "./App";
import type { UnitTableOptions, UnitGroup } from "./types";
import "./index.css";

export type UnitTableProps = {
    apiKey: string;
    environment?: string;
    options?: UnitTableOptions;
    initialUnitGroups?: UnitGroup[];
};

export const UnitTable: React.FC<UnitTableProps> = ({ apiKey, environment, options, initialUnitGroups }) => {
    const [store] = useState(createStore);
    return (
        <Provider store={store}>
            <App apiKey={apiKey} environment={environment} options={options} initialUnitGroups={initialUnitGroups} />
        </Provider>
    );
};
